// External
import { useMemo } from 'react';

// Providers
import { useDeviceInfo } from '../providers/DeviceInfoProvider';

// Utils
import platform from '../utils/platform';
import { createConfigMatcher, usePlayerConfig } from '../components/Player/utils';

/**
 * Checks if the app should be closed completely, according to the config.
 * @returns {boolean}
 */
export function useCloseAppCompletely() {
  const { osName } = platform;
  const { sdkVersion } = useDeviceInfo() || {};
  const { config } = usePlayerConfig();

  const configMatcher = useMemo(() => createConfigMatcher({
    osName,
    osVersion: sdkVersion,
  }), [osName, sdkVersion]);

  const shouldCloseAppCompletely = useMemo(
    () => configMatcher(config?.shouldCloseAppCompletely),
    [config?.shouldCloseAppCompletely, configMatcher],
  );

  return shouldCloseAppCompletely || false;
}
